import { socket } from './config';

export default {
  getExpertsList: () => {
    const query = JSON.stringify({
      message: `{
          experts {
            expertId
            name
            description
            photoPath
            rating
            consultations
          }
        }`,
      queryName: 'experts',
    });
    socket.emit('graphql', query);
  },
  getChangeExpertReasons: () => {
    const query = JSON.stringify({
      message: `{
          expertChangeReasons {
            id
            title
            customText
          }
        }`,
      queryName: 'expertChangeReasons',
    });
    socket.emit('graphql', query);
  },
};
